export const GET_PRODUCT_ANSWER_LIST="GET_PRODUCT_ANSWER_LIST"
export const CLEAR_PRODUCT_ANSWER_LIST="CLEAR_PRODUCT_ANSWER_LIST"